/*
 * @Author: liukai
 * @since: 2022-04-13 14:44:14
 * @LastAuthor: liukai
 * @lastTime: 2022-04-13 17:38:43
 */
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './css/wap/index.scss'
const app = createApp(App);
app.use(router);
app.mount('#app');
